// @flow
import { colors } from 'bench-style-constants';
import React from 'react';
import styled from 'styled-components';

const Highlight = styled.mark`
  background: ${colors.ring};
`;

type HighlightKeywordProps = {
  children?: string,
  keyword?: string,
};

const HighlightKeyword = ({ children, keyword }: HighlightKeywordProps) => {
  if (!children || !keyword) {
    return children;
  }
  const textLowerCase = children.toLowerCase();
  const keywordLowerCase = keyword.trim().toLowerCase();
  const keywordLength = keyword.length;
  const textFragments = [];
  let indexOfKeyword = textLowerCase.indexOf(keywordLowerCase);
  let indexAtEndOfLastFragment = 0;
  while (indexOfKeyword !== -1) {
    textFragments.push(
      children.substr(indexAtEndOfLastFragment, indexOfKeyword - indexAtEndOfLastFragment),
    );
    textFragments.push(
      <Highlight data-test-id="highlighted-keyword" key={indexOfKeyword}>
        {children.substr(indexOfKeyword, keywordLength)}
      </Highlight>,
    );
    indexAtEndOfLastFragment = indexOfKeyword + keywordLength;
    indexOfKeyword = textLowerCase.indexOf(keywordLowerCase, indexAtEndOfLastFragment);
  }
  textFragments.push(children.substr(indexAtEndOfLastFragment));
  return textFragments;
};

export default HighlightKeyword;
